import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useGetMyInfoQuery } from 'src/hooks/useGetMyInfoQuery';
import { saveLastAccessedProjectId } from 'src/utils/projectStorage';
import { ProjectNotFoundPage } from 'src/views/ErrorPages/NoPermissionsPage';

import { useNavigate } from 'components/Nav';

// This magic token represents an empty project to be used in the URL,
// this token will cause a redirect to the select project page
const emptyProjectMagicToken = '_';

type ProjectProtectedPageProps = {
  children: React.ReactNode;
};

export const ProjectProtectedPage = ({ children }: ProjectProtectedPageProps) => {
  const { projectId } = useParams();
  const { data: myInfo } = useGetMyInfoQuery();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (projectId && projectId === emptyProjectMagicToken) {
      // Choose the project, then come back to this page with its query and hash.
      navigate('/select-project', {
        state: { from: location.pathname + location.search + location.hash },
      });
    }
  }, [projectId, navigate, location.pathname, location.search, location.hash]);

  useEffect(() => {
    if (myInfo?.projectRoles && projectId && !myInfo.projectRoles[projectId]) {

      console.error('User does not have access to this project');
    }
  }, [myInfo, projectId]);

  // Save the last accessed project ID
  useEffect(() => {
    if (projectId && projectId !== emptyProjectMagicToken && myInfo?.projectRoles?.[projectId]) {
      saveLastAccessedProjectId(projectId);
    }
  }, [projectId, myInfo]);

  if (myInfo?.projectRoles && projectId && !myInfo.projectRoles[projectId]) {
    return <ProjectNotFoundPage />;
  }

  return children;
};
